import { initializeApp, getApps } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyCaB_HYM60QX8NGpbIudNt-5V2WvrP2HOM',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||'tavlapro-203b2.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'tavlapro-203b2',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'tavlapro-203b2.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '401689467609',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:401689467609:web:de250715fb28b552f3fcc8',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-BTW363X4SH',
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const auth = getAuth(app);

const REDIRECT_PENDING_KEY = 'bg_google_redirect_pending';

function createGoogleProvider() {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  return provider;
}

export async function beginGoogleSignIn({ mode = 'popup' } = {}) {
  const provider = createGoogleProvider();
  if (mode === 'redirect') {
    try {
      sessionStorage.setItem(REDIRECT_PENDING_KEY, '1');
    } catch (_err) {
      // ignore
    }
    await signInWithRedirect(auth, provider);
    return null;
  }

  const result = await signInWithPopup(auth, provider);
  const idToken = await result.user.getIdToken(true);
  return idToken;
}

export async function consumeGoogleRedirectResult() {
  const result = await getRedirectResult(auth);
  if (!result?.user) return null;
  const idToken = await result.user.getIdToken(true);
  try {
    sessionStorage.removeItem(REDIRECT_PENDING_KEY);
  } catch (_err) {
    // ignore
  }
  return idToken;
}

export function wasGoogleRedirectPending() {
  try {
    return sessionStorage.getItem(REDIRECT_PENDING_KEY) === '1';
  } catch (_err) {
    return false;
  }
}

export function clearGoogleRedirectPending() {
  try {
    sessionStorage.removeItem(REDIRECT_PENDING_KEY);
  } catch (_err) {
    // ignore
  }
}
